import React, { FC, memo } from 'react';
import { Container } from './styles';
import { Props } from './types';

const VideoGrid: FC<Props> = ({ children, ...rest }) => (
  <Container {...rest}>{children}</Container>
);

export default memo(VideoGrid);
